import { createFeatureSelector, createSelector } from '@ngrx/store';
import {SymbolEntityState, symbolsFeatureKey} from '../_reducer/symbol.reducer';
import {DrawSymbol} from '../_interface/symbol.model';
import {Dictionary} from '@ngrx/entity';
import {SymbolCategoriesEnum} from '../_interface/symbolCategories.enum';
import {schemaEntityState} from './schema.selectors';

export const symbolEntityState = createFeatureSelector<SymbolEntityState>(symbolsFeatureKey);
export const selectEditSymbol = createSelector(symbolEntityState, ({edit}) => edit);
export const selectSymbolsLoaded = createSelector(schemaEntityState, ({loaded}) => loaded);
export const selectAllEntities = createSelector(symbolEntityState, ({entities}): Dictionary<DrawSymbol> => entities);
export const selectAllList = createSelector(symbolEntityState, ({entities}): DrawSymbol[] => Object.values(entities));
export const selectCategories = createSelector(symbolEntityState, () => Object.keys(SymbolCategoriesEnum));
export const selectAllListByCategory = createSelector(
	selectAllList, selectCategories, (symbols, cats): {category: string, symbols: DrawSymbol[]}[] => {
	return cats.map(cat => ({category: cat, symbols: symbols.filter(symbol => symbol.category === cat)}));
});
export const selectCountAll = createSelector(symbolEntityState, ({entities}) => Object.values(entities || []).length);
export const selectOne = (symbolId: string) => createSelector(symbolEntityState, ({entities}): DrawSymbol => entities[symbolId]);
export const selectAreaSymbolMap = createSelector(selectAllList, (entities): Dictionary<string[]> =>
	entities.reduce((acc, {symbolId, areaIds}) => ({...acc, [symbolId]: areaIds}), {})
);

